import { cn } from "@/lib/utils";

export default function KPICard({ label, value, delta, deltaTone = "muted", icon: Icon, testid, className }) {
    const toneCls = {
        success: "text-emerald-600 dark:text-emerald-400",
        destructive: "text-red-600 dark:text-red-400",
        muted: "text-muted-foreground",
    }[deltaTone];

    return (
        <div
            data-testid={testid}
            className={cn(
                "group surface border border-border rounded-md p-5 transition-all hover:-translate-y-px hover:shadow-sm fadeup",
                className
            )}
        >
            <div className="flex items-start justify-between mb-4">
                <div className="overline">{label}</div>
                {Icon && (
                    <div className="w-8 h-8 rounded-md bg-background border border-border flex items-center justify-center">
                        <Icon className="w-4 h-4 text-primary" />
                    </div>
                )}
            </div>
            <div className="font-heading text-3xl sm:text-4xl font-bold tabular tracking-tighter">
                {value}
            </div>
            {delta && (
                <div className={cn("text-xs mt-2 font-medium", toneCls)}>{delta}</div>
            )}
        </div>
    );
}
